// The dashboard modules a Standard Admin can be given access to. Super Admins
// always have every module. `paths` are the admin route prefixes each module
// owns; routes that no module claims are open to every admin.
export interface AdminModule {
  key: string;
  label: string;
  paths: string[];
}

export const ADMIN_MODULES: AdminModule[] = [
  { key: "dashboard", label: "Dashboard Overview", paths: ["/admindashboard"] },
  {
    key: "blog",
    label: "Blog Management",
    paths: ["/admin/blog-management", "/admin/categories", "/admin/create-blog"],
  },
  {
    key: "video_teachings",
    label: "Video Teachings",
    paths: ["/admin/video-teachings", "/admin/video-categories"],
  },
  { key: "testimonies", label: "Testimony Management", paths: ["/admin/testimonies"] },
  { key: "prayer_requests", label: "Prayer Request Management", paths: ["/admin/prayer-requests"] },
  { key: "salvation", label: "Salvation Management", paths: ["/admin/salvation"] },
  { key: "finance", label: "Finance Management", paths: ["/admin/finance"] },
  { key: "conferences", label: "Conference Management", paths: ["/admin/conferences"] },
  { key: "media_spotlight", label: "Media Spotlight Management", paths: ["/admin/media-spotlight"] },
  { key: "library", label: "Digital Library Management", paths: ["/admin/library"] },
  { key: "events", label: "Events & Announcements", paths: ["/admin/events"] },
  { key: "messages", label: "Messages", paths: ["/admin/messages"] },
  { key: "groups", label: "Groups & Communities", paths: ["/admin/groups"] },
  { key: "partnerships", label: "Partnerships Management", paths: ["/admin/partnerships"] },
  { key: "members", label: "Member Directory", paths: ["/admin/members"] },
  { key: "announcements", label: "Announcements Management", paths: ["/admin/announcements"] },
  { key: "access_control", label: "Access Control", paths: ["/admin/switch-role"] },
  { key: "admin_management", label: "Admin Management", paths: ["/admin/admins"] },
];

export const ALL_MODULE_KEYS = ADMIN_MODULES.map((m) => m.key);

const matches = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`) || pathname.startsWith(`${prefix}-`);

export const moduleForPath = (pathname: string): AdminModule | undefined =>
  ADMIN_MODULES.find((m) => m.paths.some((p) => matches(pathname, p)));

// Labels in the same order as the checkbox grid
export const moduleLabels = (keys: string[]) =>
  ADMIN_MODULES.filter((m) => keys.includes(m.key)).map((m) => m.label);

// `modules` is null when the backend didn't send a list for this admin; until
// /auth/me returns one, every admin keeps full access rather than being locked out.
export const canAccessModule = (
  type: string | null,
  modules: string[] | null,
  module: AdminModule | undefined
) => !module || type === "superadmin" || modules === null || modules.includes(module.key);
